import { useEffect, useState } from "react";
import { cashierAxios } from "../../axiosInstance";
import {
  isOffline,
  isReachable,
  probeServer,
  setReachable,
  subscribeReachability,
} from "./reachability";

const PROBE_EVERY = 8 * 1000;

// "Online" means the server answers, not just that the browser has a network.
export default function useOnlineStatus() {
  const [online, setOnline] = useState(!isOffline());
  useEffect(() => {
    const update = () => setOnline(!isOffline());
    const on = () => {
      setReachable(true);
      update();
    };
    window.addEventListener("online", on);
    window.addEventListener("offline", update);
    const unsubscribe = subscribeReachability(update);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", update);
      unsubscribe();
    };
  }, []);

  // While the server can't be reached, keep checking so the till recovers by
  // itself once the internet is back.
  useEffect(() => {
    if (online || navigator.onLine === false || isReachable()) return undefined;
    const id = setInterval(async () => {
      if (await probeServer(cashierAxios.defaults.baseURL)) setReachable(true);
    }, PROBE_EVERY);
    return () => clearInterval(id);
  }, [online]);

  return online;
}
